export interface ContactMessageRequest {
    id: string;
    name: string;
    email: string;
    phone: string;
    message: string;
}

export interface ContactMessage {
    contactId: string;
    name: string;
    email: string;
    phone: string;
    message: string;
}

export function ContactActions() {
    function createRequest(
        id: string,
        name: string,
        email: string,
        phone: string,
        message: string,
    ): ContactMessageRequest {
        return {
            id: id,
            name: name,
            email: email,
            phone: phone,
            message: message,
        };
    }

    function createContactMessage(
        contactId: string,
        name: string,
        email: string,
        phone: string,
        message: string,
    ): ContactMessage {
        return {
            contactId: contactId,
            name: name,
            email: email,
            phone: phone,
            message: message,
        };
    }

    function deserialize(object: string): ContactMessage[] {
        const parseResponse = JSON.parse(JSON.stringify(object));
        return parseResponse.map((contactMessage: ContactMessage) => {
            return createContactMessage(
                contactMessage.contactId,
                contactMessage.name,
                contactMessage.email,
                contactMessage.phone,
                contactMessage.message,
            );
        });
    }

    return {
        createRequest,
        deserialize,
    };
}
